// AppRouter.tsx
import { BrowserRouter, Routes, Route, useParams } from 'react-router-dom';
import NewApp from './NewApp';
import PostPage from './page/PostPage';
import PostListPage from './page/PostListPage';

const PostPageWrapper = () => {
  const { id } = useParams();
  const number = id ? parseInt(id, 10) : 1; // 숫자로 변환 (기본값 1)
  return <PostPage number={number} />;
};

const AppRouter = () => {
  return (
    
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<NewApp />} />
        <Route path="/posts" element={<PostListPage />} />
        <Route path="/posts/:id" element={<PostPageWrapper />} />
      </Routes>
    </BrowserRouter>
  
  );
};

export default AppRouter
